/*
 * @Author: 小周
 * @Date: 2024-07-26 10:17:52
 * @LastEditTime: 2024-07-26 10:34:06
 * @LastEditors: MrZHLF
 * @Description: App交互方法
 */
import { checkDevice, isCheckApp } from './index'
import dx from './jdx'

/**
 * @author 小周先生
 * @returns Promise<string>
 * @description 获取token ，如果没有token，跳转App登录页面
 */
export async function getTokenInAppAndRedirect() {
  const res = await isCheckApp()
  // 如果为true
  if (res) {
    const token = await dx.getDxAuth()
    if ('' != token) {
      return token
    } else {
      console.log('获取token失败！')
    }
  } else {
    console.log('不在app环境当中！')
    return false
  }
}

/**
 *
 * @author 小周先生
 * @description app环境下获取token，并不进行跳转登录
 */
export async function isInAppAndGetToKenWithOutRedirect() {
  const res = await isCheckApp()
  let xPhone = checkDevice()
  if (res) {
    if (xPhone == 'IOS') {
      if (window.iOSInfo) {
        let iOSInfo = JSON.parse(JSON.stringify(window.iOSInfo))
        console.log('init ios get jwt value', iOSInfo)
        return iOSInfo.token
      }
    } else {
      if (window.Android && window.Android.getFirstToken) {
        let token = window.Android.getFirstToken()
        console.log('init android get jwt value', token)
        return token //token
      }
    }
  } else {
    return false
  }
}

/**
 * @author 小周先生
 * @description 返回App上一级页面
 */
export function appRouter() {
  var photoType = checkDevice()
  if ('IOS' == photoType) {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.webBack
    ) {
      window.webkit.messageHandlers.webBack.postMessage({})
    }
  } else if ('Android' == photoType) {
    window.Android.webBack()
  }
}

/**
 * @author 小周先生
 * @description 禁用App手势滑动
 */
export function disableBack() {
  var photoType = checkDevice()
  if ('IOS' == photoType) {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.disableGestureBackForward
    ) {
      window.webkit.messageHandlers.disableGestureBackForward.postMessage({
        disable: true,
      })
    }
  } else if ('Android' == photoType) {
    window.Android &&
      window.Android.tongYong(
        'disableGestureBackForward',
        JSON.stringify({ disable: true })
      )
  }
}

/**
 * @author 小周先生
 * @param {Object} item 跳转参数
 * @description 打开App详情或者H5详情
 */
export async function openArticle(item) {
  let device = checkDevice()
  const res = await isCheckApp()
  if (res) {
    if (device == 'IOS') {
      window.webkit.messageHandlers.articleIdJump.postMessage({
        articleId: item.id,
      })
    } else if (device == 'Android') {
      let newsId = item.id
      window.Android &&
        window.Android.tongYong('articleIdJump', JSON.stringify({ newsId }))
    }
  } else {
    window.location.href = item.shareUrl ? item.shareUrl : item.visitUrl
  }
}

/**
 * @author 小周先生
 * @param {object} item 跳转参数 根据appId==1处理是新大象号还是融合号
 * @description 跳转大象号
 */
export async function openDxh(item) {
  let device = checkDevice()
  const res = await isCheckApp()
  let obj = {}
  if (item.appId == 1) {
    obj.dxnumId = item.id
  } else {
    obj.fusionId = item.id
  }
  if (res) {
    if (device == 'IOS') {
      //ios
      window.webkit.messageHandlers.fusionIdJump.postMessage({
        ...obj,
      })
    } else if (device == 'Android') {
      //安卓
      window.Android &&
        window.Android.tongYong(
          'fusionIdJump',
          JSON.stringify({
            ...obj,
            name: item.name || item.articleOriginName,
          })
        )
    }
  } else {
    let appUrl = window.location.href
    wakeApp(appUrl, 5)
  }
}

/**
 * @author 小周先生
 * @param {string} schemeId 后台配置的模板id
 * @description 打开App配置模板
 */
export async function openTemplete(schemeId) {
  let device = checkDevice()
  const res = await isCheckApp()
  if (res) {
    if (device == 'IOS') {
      //ios
      window.webkit.messageHandlers.templeteListJump.postMessage({
        schemeId: schemeId,
      })
    } else if (device == 'Android') {
      //安卓
      window.Android &&
        window.Android.tongYong(
          'templeteListJump',
          JSON.stringify({ schemeId })
        )
    }
  } else {
    let appUrl = window.location.href
    wakeApp(appUrl, 5)
  }
}

/**
 * @author 小周先生
 * @param {String} id 稿件ID
 * @description 打开专题
 */
export async function openZhuanti(id) {
  let device = checkDevice()
  const res = await isCheckApp()
  if (res) {
    if (device == 'IOS') {
      //ios
      window.webkit.messageHandlers.appRoute.postMessage({
        url: `hntvdxxw://Article/zhuantiViewController?articleId=${id}`,
      })
    } else if (device == 'Android') {
      //安卓
      window.Android.appRoute(
        `hntvdxxw://Article/articleDetailViewController?articleId=${id}`
      )
    }
  } else {
    if (process.env.NODE_ENV == 'production') {
      window.location.href = `https://share.hntv.tv/news/8/${id}`
    } else {
      window.location.href = `https://pre-share.hntv.tv/news/8/${id}`
    }
  }
}

/**
 * @author 小周先生
 * @param {String} url H5地址活动稿件ID
 * @param {*} articleType 稿件类型
 * @description 唤醒App
 */
export function wakeApp(url, articleType) {
  url = encodeURI(url)
  let device = checkDevice()
  if (device == 'IOS') {
    //ios
    window.location.href = `https://www.hndt.com/dowload/dxXw/index.html?id=${url}&msgType=${articleType}`
  } else if (device == 'Android') {
    //安卓
    window.location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=com.hnr.dxxw&android_schema=schemedxxw%3a%2f%2fhostdxxw%3a8080%2fpath?id=${url}%26msgType=${articleType}`
  }
}

/**
 * @author 小周先生
 * @param {String} articleId 文章ID
 * @param {*} channelId 栏目ID
 * @description 打开app竖版视频
 */
export function openScrollVideo(articleId, channelId) {
  let device = checkDevice()
  let count = '30'
  let androidRouteUrl = `hntvdxxw://Common/viewController?className=com.hnr.dxxw.activity.VerticalElephantVideoActivity&KEY_JUMP_ITEM_ID=str_${articleId}&code=str_${channelId}&size=str_${count}`
  let iosRouteUrl = `hntvdxxw://Article/xiangshipinPlayerViewController?listChannelId=${channelId}&articleId=${articleId}&pageSize=${count}`

  if (device == 'IOS') {
    //ios
    window.webkit &&
      window.webkit.messageHandlers.appRoute.postMessage({
        url: iosRouteUrl,
      })
  } else if (device == 'Android') {
    //安卓
    window.Android &&
      window.Android.tongYong(
        'appRoute',
        JSON.stringify({
          url: androidRouteUrl,
        })
      )
  }
}
